import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '@/locales/en/common.json';
import enAuth from '@/locales/en/auth.json';
import enDashboard from '@/locales/en/dashboard.json';
import enOrders from '@/locales/en/orders.json';
import enProfile from '@/locales/en/profile.json';
import enCrm from '@/locales/en/crm.json';
import enCatalog from '@/locales/en/catalog.json';
import ruCommon from '@/locales/ru/common.json';
import ruAuth from '@/locales/ru/auth.json';
import ruDashboard from '@/locales/ru/dashboard.json';
import ruOrders from '@/locales/ru/orders.json';
import ruProfile from '@/locales/ru/profile.json';
import ruCrm from '@/locales/ru/crm.json';
import ruCatalog from '@/locales/ru/catalog.json';
import esCommon from '@/locales/es/common.json';
import esAuth from '@/locales/es/auth.json';
import esDashboard from '@/locales/es/dashboard.json';
import esOrders from '@/locales/es/orders.json';
import esProfile from '@/locales/es/profile.json';
import esCrm from '@/locales/es/crm.json';
import esCatalog from '@/locales/es/catalog.json';

export const SUPPORTED_LANGUAGES = ['en', 'ru', 'es'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_NAMESPACE = 'common';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru', 'es'],
    ns: ['common', 'auth', 'dashboard', 'orders', 'profile', 'crm', 'catalog'],
    defaultNS: DEFAULT_NAMESPACE,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    resources: {
      en: { common: enCommon, auth: enAuth, dashboard: enDashboard, orders: enOrders, profile: enProfile, crm: enCrm, catalog: enCatalog },
      ru: { common: ruCommon, auth: ruAuth, dashboard: ruDashboard, orders: ruOrders, profile: ruProfile, crm: ruCrm, catalog: ruCatalog },
      es: { common: esCommon, auth: esAuth, dashboard: esDashboard, orders: esOrders, profile: esProfile, crm: esCrm, catalog: esCatalog },
    },
  });

export default i18n;
